import { CreateNewProjectThemeSizeConfig } from './types';

const small: CreateNewProjectThemeSizeConfig = {
  createNewProject: {},
};

export default small;
